<template>

    <div>

        <h1 class="mt-4">Benify excel</h1>

        <div class="content-container">

            <h3>Välj benify excel</h3>
            <div class="row mb-8">
                <div class="col-5">
                    <input class="form-control form-control-sm" type="file" id="formFile" @change="upload">
                </div>
                <div class="col-5">
                    <div style="padding-top:2px;" v-if="loading"><img src="/images/card/spinner.gif" style="height: 32px; margin-right: 8px;"> Bearbetar fil...</div>
                </div>
            </div>

            <div class="alert alert-success mb-8" v-if="success">
                <a href="/benify-excel/download" target="_blank">Hämta resultat</a>
            </div>

        </div>

    </div>

</template>

<script>
import axios from 'axios'

export default {

    data () {
        return {
            success: false,
            loading: false,
            filename: null
        }
    },

    methods: {

        upload (event) {
            this.loading = true

            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('excel', files[0], files[0].name)

            this.success = false

            axios.post(
                '/benify-excel/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.filename = response.data.filename
                    this.success = true
                    this.loading = false
                })
                .catch(error => {
                    alert('Uppladdningen misslyckades, vänligen försök igen.')
                })
                .finally(function () {
                    document.getElementById('formFile').value = null
                })
        }

    }
}
</script>
